export const toggleStyles = {
  thumbOff: {
    backgroundColor: '#0E2C44',
  },
  trackOff: {
    backgroundColor: '#0E2C44',
    opacity: '0.5',
  },
  thumbOnGreen: {
    backgroundColor: '#54C06E',
  },
  trackOnGreen: {
    backgroundColor: '#54C06E',
    opacity: '0.5',
  },
};

export const whiteToggleStyles = {
  thumbOff: {
    backgroundColor: '#FFFFFF',
  },
  trackOff: {
    backgroundColor: '#FFFFFF',
    opacity: '0.5',
  },
  thumbOn: {
    backgroundColor: '#0E2C44',
  },
  trackOn: {
    backgroundColor: '#FFFFFF',
    opacity: '1',
  },
};
